import { render, staticRenderFns } from "./hotTask.vue?vue&type=template&id=104778d6&scoped=true"
import script from "./hotTask.vue?vue&type=script&lang=js"
export * from "./hotTask.vue?vue&type=script&lang=js"
import style0 from "./hotTask.vue?vue&type=style&index=0&id=104778d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104778d6",
  null
  
)

export default component.exports